import { useCallback, useEffect, useState } from 'react'
import type { ColumnProps } from 'antd/es/table'
import type { ITemplate } from '@src/interfaces'
import dynamicSort from '@src/helpers/dynamic-sort'

interface ITemplatesTableColumn<T> extends ColumnProps<T> {
  key: 'title' | 'workspace_title' | 'active' | 'actions'
  sorteable?: boolean
  visible?: boolean
}

export type TemplatesTableColumn = ITemplatesTableColumn<ITemplate>

export interface IColumnHeadersOverwrite {
  key: 'title' | 'workspace_title' | 'active' | 'actions'
  visible: boolean
  [key: string]: unknown
}

export const useHeaders = (
  columnHeaders: TemplatesTableColumn[],
  overwriteColumns?: IColumnHeadersOverwrite[]
): TemplatesTableColumn[] => {
  let tableColumnHeaders = columnHeaders

  if (overwriteColumns) {
    tableColumnHeaders = columnHeaders.map((header) => {
      const findHeader = (column: IColumnHeadersOverwrite) => column.key === header.key
      const newHeader = overwriteColumns.find(findHeader) || {}

      return { ...header, ...newHeader }
    })
  }

  return tableColumnHeaders
}

interface orderParams {
  field: string
  order: string
}

export const useOrderedTemplates = (
  templates: ITemplate[]
): [ITemplate[], (params: orderParams) => void] => {
  const [orderedTemplates, setOrderedTemplates] = useState(templates)

  useEffect(() => {
    setOrderedTemplates(templates)
  }, [templates])

  const handleSortChange = useCallback(
    ({ field, order }: orderParams) => {
      const ordered = templates.sort(dynamicSort(field, order))
      setOrderedTemplates(ordered)
    },
    [templates]
  )

  return [orderedTemplates, handleSortChange]
}
